/*
	支払方法管理画面
	保存済みカード一覧表示、選択画面
*/

import React, { memo } from 'react';
import classes from './select-other-cards.module.scss';
import { PaymentToken } from 'requests/RequestPayment';
import { Hr } from 'components/atoms/Hr';
import { displayCardBrandImage } from '../card-brand/CardBrand';

type Props = {
	paymentTokens?: PaymentToken[];
	isCardSelected?: (i: number) => boolean;
	onChangeEvent: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
	selectDeleteCard: (index: number) => void;
};
export const SelectOtherCards = memo((props: Props) => {
	const { paymentTokens, isCardSelected, onChangeEvent } = props;

	return (
		<>
			<div className={classes.paymentTokenRowHead}>
				<div className={'info-head ' + classes.paymentTokenRowHeadCol} />
				<div className={'info-head ' + classes.paymentTokenRowHeadCol} />
				<div className={'info-head ' + classes.paymentTokenRowHeadCol}>カード番号</div>
				<div className={'info-head ' + classes.paymentTokenRowHeadCol}>有効期限</div>
			</div>
			{paymentTokens.map((t, i) => {
				return (
					<>
						<Hr />
						<div className={classes.paymentTokenRow}>
							<div className="radio-box">
								<ul>
									<li className={classes.paymentTokenLi}>
										<label
											className={`radio-label ${classes.paymentTokenLabel} ${isCardSelected(i) ? 'is-active' : ''}`}
											htmlFor={`after${i}`}
										>
											<input
												type="radio"
												id={`after${i}`}
												name={`method${i}`}
												value={i}
												checked={isCardSelected(i)}
												onChange={onChangeEvent}
											/>
										</label>
										<div className={classes.paymentTokenCol}>{displayCardBrandImage(t.brand)}</div>
										<div className={classes.paymentTokenCol}>{`**** **** **** ${t.last_digits}`}</div>
										<div className={classes.paymentTokenCol}>{`${t.expiry.split('-')[1]} / ${
											t.expiry.split('-')[0]
										}`}</div>
									</li>
								</ul>
							</div>
						</div>
					</>
				);
			})}
		</>
	);
});
